import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './InnerHTML.styles';

function InnerHTML({ html = '', ...props }) {
  return (
    <Wrapper
      dangerouslySetInnerHTML={{ __html: html }}
      {...props}
      className="InnerHTML"
    />
  );
}

InnerHTML.propTypes = {
  html: PropTypes.string,
};

export default memo(InnerHTML);
